import { UnavailableDatetime, useGetServiceProviderCalendarUnavailableDateTimeBoundsForAppointmentLazyQuery } from 'Generated/graphql';
import { useEffect, useState } from 'react';

const useServiceProviderCalendarUnavailableDateTimeBoundsForAppointment = (
  serviceProviderUid: string,
  locationUid: string | undefined | null,
  from: number,
  to: number,
  excludeBookingUid?: string,
) => {
  const [unavailableTimeBounds, setUnavailableTimeBounds] =
    useState<null | UnavailableDatetime[]>(null);
  const [getUnavailableTimeBounds] =
    useGetServiceProviderCalendarUnavailableDateTimeBoundsForAppointmentLazyQuery();

  useEffect(() => {
    if (locationUid) {
      getUnavailableTimeBounds({
        variables: {
          serviceProviderUid,
          locationUid,
          from,
          to,
          excludeBookingUid,
        },
      }).then(res => {
        if (res.data?.getServiceProviderCalendarUnavailableDateTimeBoundsForAppointment) {
          setUnavailableTimeBounds(
            res.data.getServiceProviderCalendarUnavailableDateTimeBoundsForAppointment
          );
        }
      });
    }
  }, [locationUid]);

  return unavailableTimeBounds;
};

export default useServiceProviderCalendarUnavailableDateTimeBoundsForAppointment;
